import React, { useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Header from "../Header";

function ThreeSixtyReview() {
  const ratingOptions = [1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5];
  const raterTypes = ['Manager', 'Peer', 'Subordinate', 'Customer'];
  const defaultEmployees = [
    { name: 'John', surname: 'Doe', position: 'Manager', department: 'HR' },
    { name: 'Jane', surname: 'Smith', position: 'Developer', department: 'IT' },
    { name: 'Alice', surname: 'Johnson', position: 'Analyst', department: 'Finance' },
  ];
  const defaultCustomers = [
    { name: 'Acme Corp', surname: '', position: 'Client', department: 'Sales' },
    { name: 'Beta Inc', surname: '', position: 'Client', department: 'Marketing' },
  ];
  const [reviews, setReviews] = useState([
    {
      competency: 'Leadership',
      feedback: 'Demonstrates strong decision-making skills',
      raterType: 'Manager',
      rating: 4.0,
      ratedEntity: 'John Doe',
    },
    {
      competency: 'Communication',
      feedback: 'Effectively communicates ideas in team meetings',
      raterType: 'Peer',
      rating: 3.5,
      ratedEntity: 'Jane Smith',
    },
  ]);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showEntityModal, setShowEntityModal] = useState(false);
  const [newReview, setNewReview] = useState({
    competency: '',
    feedback: '',
    raterType: '',
    rating: null,
    ratedEntity: '',
  });
  const [selectedReviewIndex, setSelectedReviewIndex] = useState(null);
  const [isEditingReview, setIsEditingReview] = useState(false);

  const handleAddReview = () => {
    console.log('handleAddReview called with newReview:', newReview);
    const missingFields = [];
    if (!newReview.competency) missingFields.push('Competency');
    if (!newReview.feedback) missingFields.push('Feedback');
    if (!newReview.raterType) missingFields.push('Rater Type');
    if (!newReview.ratedEntity) missingFields.push('Rated Employee/Customer');

    if (missingFields.length > 0) {
      alert(`Please fill in the following required fields: ${missingFields.join(', ')}.`);
      console.log('Validation failed, missing required fields:', missingFields);
      return;
    }

    console.log('Required fields valid, adding Review');
    setReviews([...reviews, { ...newReview, rating: newReview.rating ? parseFloat(newReview.rating) : null }]);
    setNewReview({
      competency: '',
      feedback: '',
      raterType: '',
      rating: null,
      ratedEntity: '',
    });
    setShowReviewModal(false);
    console.log('Review added, updated reviews:', reviews);
  };

  const handleEditReview = (index) => {
    console.log('handleEditReview called for index:', index);
    setSelectedReviewIndex(index);
    setNewReview({ ...reviews[index] });
    setIsEditingReview(true);
    setShowReviewModal(true);
  };

  const handleSaveEditReview = () => {
    console.log('handleSaveEditReview called with newReview:', newReview);
    console.log('selectedReviewIndex:', selectedReviewIndex);
    const missingFields = [];
    if (!newReview.competency) missingFields.push('Competency');
    if (!newReview.feedback) missingFields.push('Feedback');
    if (!newReview.raterType) missingFields.push('Rater Type');
    if (!newReview.ratedEntity) missingFields.push('Rated Employee/Customer');

    if (missingFields.length > 0) {
      alert(`Please fill in the following required fields: ${missingFields.join(', ')}.`);
      console.log('Validation failed, missing required fields:', missingFields);
      return;
    }

    console.log('Required fields valid, updating Review');
    const updatedReviews = [...reviews];
    updatedReviews[selectedReviewIndex] = { ...newReview, rating: newReview.rating ? parseFloat(newReview.rating) : null };
    setReviews(updatedReviews);
    setNewReview({
      competency: '',
      feedback: '',
      raterType: '',
      rating: null,
      ratedEntity: '',
    });
    setShowReviewModal(false);
    setSelectedReviewIndex(null);
    setIsEditingReview(false);
    console.log('Review updated, updated reviews:', updatedReviews);
  };

  const handleDeleteReview = () => {
    console.log('handleDeleteReview called for index:', selectedReviewIndex);
    const updatedReviews = reviews.filter((_, index) => index !== selectedReviewIndex);
    setReviews(updatedReviews);
    setNewReview({
      competency: '',
      feedback: '',
      raterType: '',
      rating: null,
      ratedEntity: '',
    });
    setShowReviewModal(false);
    setSelectedReviewIndex(null);
    setIsEditingReview(false);
    console.log('Review deleted, updated reviews:', updatedReviews);
  };

  const handleSelectEntity = (entity) => {
    console.log('handleSelectEntity called with entity:', entity);
    setNewReview({ ...newReview, ratedEntity: `${entity.name} ${entity.surname}`.trim() });
    setShowEntityModal(false);
  };

  const handleRatingChange = (index, value) => {
    console.log('handleRatingChange called for index:', index, 'value:', value);
    const updatedReviews = [...reviews];
    updatedReviews[index].rating = value ? parseFloat(value) : null;
    setReviews(updatedReviews);
  };

  const calculateRaterStats = (raterType) => {
    const filteredReviews = reviews.filter((review) => review.raterType === raterType);
    const count = filteredReviews.filter((review) => review.rating !== null).length;
    const averageRating =
      count > 0
        ? filteredReviews
            .filter((review) => review.rating !== null)
            .reduce((sum, review) => sum + review.rating, 0) / count
        : null;
    return {
      count,
      averageRating: averageRating ? parseFloat(averageRating.toFixed(1)) : null,
    };
  };

  const renderStars = (rating) => {
    if (rating === null) return 'Not Rated';
    return [...Array(5)].map((_, i) => (
      <i key={i} className={`bi ${i < rating ? 'bi-star-fill' : 'bi-star'} text-warning me-1`} />
    ));
  };

  return (
      <>
          <Header icon={"fa-solid fa-users fa-xl mx-2"} label={"Current Review Cycle / 360 Review"} />
          <main id="main" className="main">
              <div className='row'>
                  <div className='col-lg-12'>
                      <div className='card'>
                          <div className='card-body'>
                              <div className='content-block mt-2'>

                                  <div className="container mt-4">
                                      <div className="d-flex align-items-center mb-3  bg-tertiary p-2 text-light rounded">
                                          <h3 className="mb-0">360 Review</h3>
                                          <button type="button" className="btn btn-primary ms-auto" onClick={() => setShowReviewModal(true)}>
                                              Add New Review
                                          </button>
                                      </div>
                                      <div className="row g-3">
                                          <div className="col-lg-12">
                                              <div className="card h-100">
                                                  <div className="card-body">
                                                      <h5 className="card-title">Overall Score</h5>
                                                      <table className="table table-bordere">
                                                          <thead className="bg-primary text-white">
                                                          <tr>
                                                              <th>Rating Type</th>
                                                              <th>Count</th>
                                                              <th>Average Score</th>
                                                              <th>Average Stars</th>
                                                          </tr>
                                                          </thead>
                                                          <tbody>
                                                          {raterTypes.map((raterType) => {
                                                              const { count, averageRating } = calculateRaterStats(raterType);
                                                              return (
                                                                  <tr key={raterType}>
                                                                      <td>{raterType}</td>
                                                                      <td>{count}</td>
                                                                      <td>{averageRating !== null ? `${averageRating}/5` : 'Not Rated'}</td>
                                                                      <td>{renderStars(averageRating)}</td>
                                                                  </tr>
                                                              );
                                                          })}
                                                          {reviews.length === 0 && (
                                                              <tr>
                                                                  <td colSpan="4" className="text-center">No ratings available</td>
                                                              </tr>
                                                          )}
                                                          </tbody>
                                                      </table>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                      <div className="mt-4">
                                          <table className="table table-bordereds">
                                              <thead className="bg-tertiary text-white">
                                              <tr>
                                                  <th>Competency</th>
                                                  <th>Feedback</th>
                                                  <th>Rater Type</th>
                                                  <th>Rated Employee/Customer</th>
                                                  <th>Rating</th>
                                                  <th>Action</th>
                                              </tr>
                                              </thead>
                                              <tbody>
                                              {reviews.length === 0 ? (
                                                  <tr>
                                                      <td colSpan="6" className="text-center">No Reviews added</td>
                                                  </tr>
                                              ) : (
                                                  reviews.map((review, index) => (
                                                      <tr key={`review-${index}`}>
                                                          <td>
                        <textarea
                            className="form-control"
                            value={review.competency}
                            readOnly
                            disabled
                            rows={4}
                        />
                                                          </td>
                                                          <td>
                        <textarea
                            className="form-control"
                            value={review.feedback}
                            readOnly
                            disabled
                            rows={4}
                        />
                                                          </td>
                                                          <td>
                        <textarea
                            className="form-control"
                            value={review.raterType}
                            readOnly
                            disabled
                            rows={4}
                        />
                                                          </td>
                                                          <td>
                        <textarea
                            className="form-control"
                            value={review.ratedEntity}
                            readOnly
                            disabled
                            rows={4}
                        />
                                                          </td>
                                                          <td>
                                                              <select
                                                                  className="form-select"
                                                                  value={review.rating || ''}
                                                                  onChange={(e) => handleRatingChange(index, e.target.value)}
                                                              >
                                                                  <option value="">Select Rating</option>
                                                                  {ratingOptions.map((val) => (
                                                                      <option key={val} value={val}>{val}</option>
                                                                  ))}
                                                              </select>
                                                          </td>
                                                          <td>
                                                              <button
                                                                  type="button"
                                                                  className="btn btn-outline-primary btn-sm"
                                                                  onClick={() => handleEditReview(index)}
                                                              >
                                                                  Edit
                                                              </button>
                                                          </td>
                                                      </tr>
                                                  ))
                                              )}
                                              </tbody>
                                          </table>
                                      </div>
                                      <div className={`modal fade ${showReviewModal ? 'show d-block' : ''}`} style={{ backgroundColor: showReviewModal ? 'rgba(0,0,0,0.5)' : 'transparent' }}>
                                          <div className="modal-dialog">
                                              <div className="modal-content">
                                                  <div className="modal-header">
                                                      <h5 className="modal-title">{isEditingReview ? 'Edit Review' : 'Add New Review'}</h5>
                                                      <button type="button" className="btn-close" onClick={() => setShowReviewModal(false)} />
                                                  </div>
                                                  <div className="modal-body">
                                                      <div className="mb-3">
                                                          <label htmlFor="reviewCompetency" className="form-label">Competency</label>
                                                          <textarea
                                                              className="form-control"
                                                              id="reviewCompetency"
                                                              value={newReview.competency}
                                                              onChange={(e) => setNewReview({ ...newReview, competency: e.target.value })}
                                                              rows={4}
                                                          />
                                                      </div>
                                                      <div className="mb-3">
                                                          <label htmlFor="reviewFeedback" className="form-label">Feedback</label>
                                                          <textarea
                                                              className="form-control"
                                                              id="reviewFeedback"
                                                              value={newReview.feedback}
                                                              onChange={(e) => setNewReview({ ...newReview, feedback: e.target.value })}
                                                              rows={4}
                                                          />
                                                      </div>
                                                      <div className="mb-3">
                                                          <label htmlFor="reviewRaterType" className="form-label">Rater Type</label>
                                                          <select
                                                              className="form-select"
                                                              id="reviewRaterType"
                                                              value={newReview.raterType}
                                                              onChange={(e) => setNewReview({ ...newReview, raterType: e.target.value, ratedEntity: '' })}
                                                          >
                                                              <option value="">Select Rater Type</option>
                                                              {raterTypes.map((type) => (
                                                                  <option key={type} value={type}>{type}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                      <div className="mb-3">
                                                          <label htmlFor="reviewRatedEntity" className="form-label">Rated Employee/Customer</label>
                                                          <div className="input-group">
                                                              <input
                                                                  type="text"
                                                                  className="form-control"
                                                                  id="reviewRatedEntity"
                                                                  value={newReview.ratedEntity}
                                                                  readOnly
                                                                  disabled
                                                              />
                                                              <button
                                                                  type="button"
                                                                  className="btn btn-outline-primary"
                                                                  onClick={() => setShowEntityModal(true)}
                                                                  disabled={!newReview.raterType}
                                                              >
                                                                  Select Employee
                                                              </button>
                                                          </div>
                                                      </div>
                                                      <div className="mb-3">
                                                          <label htmlFor="reviewRating" className="form-label">Rating (Optional)</label>
                                                          <select
                                                              className="form-select"
                                                              id="reviewRating"
                                                              value={newReview.rating || ''}
                                                              onChange={(e) => setNewReview({ ...newReview, rating: e.target.value })}
                                                          >
                                                              <option value="">Select Rating</option>
                                                              {ratingOptions.map((val) => (
                                                                  <option key={val} value={val}>{val}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </div>
                                                  <div className="modal-footer">
                                                      <div className="d-flex w-100">
                                                          <button
                                                              type="button"
                                                              className="btn btn-danger btn-sm me-auto"
                                                              onClick={handleDeleteReview}
                                                              style={{ visibility: isEditingReview ? 'visible' : 'hidden' }}
                                                          >
                                                              Delete
                                                          </button>
                                                          <div>
                                                              <button type="button" className="btn btn-secondary me-2" onClick={() => setShowReviewModal(false)}>
                                                                  Cancel
                                                              </button>
                                                              <button
                                                                  type="button"
                                                                  className="btn btn-primary"
                                                                  onClick={isEditingReview ? handleSaveEditReview : handleAddReview}
                                                              >
                                                                  Save
                                                              </button>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                      <div className={`modal fade ${showEntityModal ? 'show d-block' : ''}`} style={{ backgroundColor: showEntityModal ? 'rgba(0,0,0,0.5)' : 'transparent' }}>
                                          <div className="modal-dialog">
                                              <div className="modal-content">
                                                  <div className="modal-header">
                                                      <h5 className="modal-title">Select {newReview.raterType === 'Customer' ? 'Customer' : 'Employee'}</h5>
                                                      <button type="button" className="btn-close" onClick={() => setShowEntityModal(false)} />
                                                  </div>
                                                  <div className="modal-body">
                                                      <table className="table table-bordered">
                                                          <thead>
                                                          <tr>
                                                              <th>Name</th>
                                                              <th>Surname</th>
                                                              <th>Position</th>
                                                              <th>Department</th>
                                                              <th>Action</th>
                                                          </tr>
                                                          </thead>
                                                          <tbody>
                                                          {(newReview.raterType === 'Customer' ? defaultCustomers : defaultEmployees).map((entity, index) => (
                                                              <tr key={`entity-${index}`}>
                                                                  <td>{entity.name}</td>
                                                                  <td>{entity.surname}</td>
                                                                  <td>{entity.position}</td>
                                                                  <td>{entity.department}</td>
                                                                  <td>
                                                                      <button
                                                                          type="button"
                                                                          className="btn btn-outline-primary btn-sm"
                                                                          onClick={() => handleSelectEntity(entity)}
                                                                      >
                                                                          Select
                                                                      </button>
                                                                  </td>
                                                              </tr>
                                                          ))}
                                                          </tbody>
                                                      </table>
                                                  </div>
                                                  <div className="modal-footer">
                                                      <button type="button" className="btn btn-secondary" onClick={() => setShowEntityModal(false)}>
                                                          Cancel
                                                      </button>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </main>
      </>
);
}

export default ThreeSixtyReview;